/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingCouponRedemption } from './BillingCouponRedemption';
import {
    BillingCouponRedemptionFromJSON,
    BillingCouponRedemptionFromJSONTyped,
    BillingCouponRedemptionToJSON,
    BillingCouponRedemptionToJSONTyped,
} from './BillingCouponRedemption';

/**
 * 
 * @export
 * @interface CreateBillingCouponRedemptionResponse
 */
export interface CreateBillingCouponRedemptionResponse {
    /**
     * 
     * @type {BillingCouponRedemption}
     * @memberof CreateBillingCouponRedemptionResponse
     */
    data: BillingCouponRedemption;
}

/**
 * Check if a given object implements the CreateBillingCouponRedemptionResponse interface.
 */
export function instanceOfCreateBillingCouponRedemptionResponse(value: object): value is CreateBillingCouponRedemptionResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateBillingCouponRedemptionResponseFromJSON(json: any): CreateBillingCouponRedemptionResponse {
    return CreateBillingCouponRedemptionResponseFromJSONTyped(json, false);
}

export function CreateBillingCouponRedemptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBillingCouponRedemptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BillingCouponRedemptionFromJSON(json['data']),
    };
}

  export function CreateBillingCouponRedemptionResponseToJSON(json: any): CreateBillingCouponRedemptionResponse {
      return CreateBillingCouponRedemptionResponseToJSONTyped(json, false);
  }

  export function CreateBillingCouponRedemptionResponseToJSONTyped(value?: CreateBillingCouponRedemptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BillingCouponRedemptionToJSON(value['data']),
    };
}

